const enums = {
  itineraryStatus: {
    BOOKED: 'booked',
    PARTIALLY_BOOKING: 'partial'
  },
  railSeatPreference: {
    OPTIONAL: 'NR',
    MANDATORY: 'SA',
    AUTO: 'AA'
  },
  railSeatPreferenceTypes: {
    POSITION: 'SeatReservationPosition',
    DIRECTION: 'SeatReservationDirection',
    COACH_TYPE: 'SeatReservationCoachType',
    ATTRIBUTE: 'SeatReservationPreferenceAttribute'
  }
};

export default enums;


// WEBPACK FOOTER //
// ./src/constants/enums.js